import type { PlatformOverride } from '../types';

// sizzlenz is the base platform — no overrides needed
export const sizzlenzOverrides: PlatformOverride = {};
